// Genre mapping from code to display name
export const GENRE_CODES: Record<string, string> = {
    '3D': '3D', // Added from CSV
    AB: 'Abstract',
    AD: 'Audio', // Added from CSV
    AI: 'AI',
    AN: 'Animation',
    AR: 'Architecture',
    BD: 'Body Art',
    BI: 'Bio Art',
    CC: 'Cultural Commentary', // Added from CSV
    CI: 'Cinematic',
    CL: 'Collage',
    CN: 'Conceptual',
    CO: 'Conceptual', // Updated from CSV (was 'Contemporary')
    CP: 'Computer Graphics',
    CR: 'Crypto Art',
    CT: 'Cartoon',
    CU: 'Cubism',
    DA: 'Digital Art', // Updated from CSV (was 'Dadaism')
    DC: 'Decorative Art', // Added from CSV
    DD: 'Domestic & Domesticity', // Added from CSV
    DE: 'Design',
    DG: 'Design', // Added from CSV (duplicate with DE)
    DI: 'Digital Painting',
    DM: 'Demoscene',
    DO: 'Documentary',
    DR: 'Drawing',
    EP: 'Expressionism',
    EX: 'Experimental',
    FA: 'Fantasy',
    FE: 'Feminist', // Added from CSV
    FI: 'Figurative',
    FN: 'Fine Art',
    FU: 'Futurism',
    GA: 'Game Art',
    GD: 'Generative Design',
    GE: 'Generative', // Updated from CSV (was 'Generative Art')
    GL: 'Glitch Art',
    GN: 'Generated', // Added from CSV
    GR: 'Graffiti Art',
    GS: 'Gender & Sexuality', // Added from CSV
    HY: 'Hyperrealism',
    IC: 'Interactive Art',
    ID: 'Installation Document', // Added from CSV
    IL: 'Illustration',
    IM: 'Impressionism',
    IN: 'Interactive', // Updated from CSV (was 'Installation Art')
    IS: 'Installation', // Added from CSV
    IT: 'Interior', // Added from CSV
    LA: 'Landscape',
    LI: 'Light', // Added from CSV
    LN: 'Landscape', // Added from CSV (duplicate with LA)
    LS: 'Light Sculpture',
    MD: 'Media', // Added from CSV
    MI: 'Minimalism',
    MP: 'Mapping', // Added from CSV
    MU: 'Music Visualization',
    MX: 'Mixed Media',
    NA: 'Narrative',
    NC: 'Neo-Conceptualism',
    NG: 'Neo-Expressionism',
    NM: 'New Media',
    NN: 'Net Art',
    NO: 'Neo-Pop Art',
    NR: 'Net Art', // Added from CSV (duplicate with NN)
    NU: 'Nature', // Updated from CSV (was 'Nu Art')
    OP: 'Op Art',
    OU: 'Outsider (Art)', // Added from CSV
    PA: 'Painting',
    PE: 'Periodical', // Updated from CSV (was 'Performance Art')
    PF: 'Performance', // Added from CSV
    PH: 'Photorealism', // Updated from CSV (was 'Photography')
    PI: 'Post Internet', // Added from CSV
    PL: 'Political', // Added from CSV
    PO: 'Pop', // Updated from CSV (was 'Pop Art')
    PR: 'Portraiture', // Updated from CSV (was 'Portrait')
    PT: 'Post Internet Art',
    RE: 'Realism',
    RT: 'Real-Time Art',
    RX: 'Remix',
    SC: 'Social', // Updated from CSV (was 'Sculpture')
    SF: 'Sci-Fi',
    SL: 'Still Life', // Added from CSV
    SO: 'Sound Art',
    ST: 'Street Art',
    SU: 'Surrealism',
    TC: 'Technology', // Added from CSV
    TR: 'Traditional',
    UR: 'Urbanism', // Added from CSV
    VG: 'Video Game',
    VI: 'Video Art',
    VJ: 'VJing',
    VR: 'VR Art',
    XP: 'Expressionism', // Added from CSV
};

// Helper function to get genre name from code
export function getGenreName(code: string): string {
    return GENRE_CODES[code] || code;
}

// Genre emojis for visual identification
export const GENRE_EMOJIS: Record<string, string> = {
    '3D': '🎲', // 3D
    AB: '🌀', // Abstract
    AD: '🎧', // Audio
    AI: '🤖', // AI
    AN: '🎬', // Animation
    AR: '🏛️', // Architecture
    BD: '💃', // Body Art
    BI: '🧬', // Bio Art
    CC: '🌍', // Cultural Commentary
    CI: '🎭', // Cinematic
    CL: '🖼️', // Collage
    CN: '💭', // Conceptual
    CO: '💭', // Conceptual (updated)
    CP: '💻', // Computer Graphics
    CR: '₿', // Crypto Art
    CT: '🦸', // Cartoon
    CU: '🔷', // Cubism
    DA: '💻', // Digital Art (updated)
    DC: '🎨', // Decorative Art
    DD: '🏠', // Domestic & Domesticity
    DE: '✨', // Design
    DG: '✨', // Design
    DI: '🖌️', // Digital Painting
    DM: '💾', // Demoscene
    DO: '📹', // Documentary
    DR: '✏️', // Drawing
    EP: '😮', // Expressionism
    EX: '🧪', // Experimental
    FA: '🐉', // Fantasy
    FE: '♀️', // Feminist
    FI: '👤', // Figurative
    FN: '🎨', // Fine Art
    FU: '🚀', // Futurism
    GA: '🎮', // Game Art
    GD: '🌐', // Generative Design
    GE: '🔄', // Generative (updated)
    GL: '📡', // Glitch Art
    GN: '🤖', // Generated
    GR: '🏙️', // Graffiti Art
    GS: '⚧️', // Gender & Sexuality
    HY: '🔍', // Hyperrealism
    IC: '👆', // Interactive Art
    ID: '📄', // Installation Document
    IL: '🖍️', // Illustration
    IM: '🌸', // Impressionism
    IN: '👆', // Interactive (updated)
    IS: '🏗️', // Installation
    IT: '🛋️', // Interior
    LA: '🏞️', // Landscape
    LI: '💡', // Light
    LN: '🏞️', // Landscape
    LS: '💡', // Light Sculpture
    MD: '📺', // Media
    MI: '⚪', // Minimalism
    MP: '🗺️', // Mapping
    MU: '🎵', // Music Visualization
    MX: '🎭', // Mixed Media
    NA: '📖', // Narrative
    NC: '🧠', // Neo-Conceptualism
    NG: '🎨', // Neo-Expressionism
    NM: '📱', // New Media
    NN: '🌐', // Net Art
    NO: '🍭', // Neo-Pop Art
    NR: '🌐', // Net Art
    NU: '🌿', // Nature (updated)
    OP: '👁️', // Op Art
    OU: '🎯', // Outsider (Art)
    PA: '🖼️', // Painting
    PE: '📰', // Periodical (updated)
    PF: '🎪', // Performance
    PH: '📸', // Photorealism (updated)
    PI: '💻', // Post Internet
    PL: '🏛️', // Political
    PO: '🍿', // Pop (updated)
    PR: '👤', // Portraiture (updated)
    PT: '💻', // Post Internet Art
    RE: '🏛️', // Realism
    RT: '⏱️', // Real-Time Art
    RX: '🔀', // Remix
    SC: '👥', // Social (updated)
    SF: '👽', // Sci-Fi
    SL: '🍎', // Still Life
    SO: '🔊', // Sound Art
    ST: '🏙️', // Street Art
    SU: '🌌', // Surrealism
    TC: '💻', // Technology
    TR: '🖌️', // Traditional
    UR: '🏙️', // Urbanism
    VG: '🕹️', // Video Game
    VI: '📹', // Video Art
    VJ: '🎬', // VJing
    VR: '🥽', // VR Art
    XP: '😮', // Expressionism
};

// Helper function to get genre emoji
export function getGenreEmoji(code: string): string {
    return GENRE_EMOJIS[code] || '🎨';
}

// Helper function to format multiple genres
export function formatGenres(primary?: string, secondary?: string): string {
    const genres: string[] = [];

    if (primary) {
        genres.push(getGenreName(primary));
    }

    if (secondary && secondary !== primary) {
        genres.push(getGenreName(secondary));
    }

    return genres.join(' • ');
}

// Helper function to format genres with emojis
export function formatGenresWithEmojis(primary?: string, secondary?: string): string {
    const genres: string[] = [];

    if (primary) {
        genres.push(`${getGenreEmoji(primary)} ${getGenreName(primary)}`);
    }

    if (secondary && secondary !== primary) {
        genres.push(`${getGenreEmoji(secondary)} ${getGenreName(secondary)}`);
    }

    return genres.join(' • ');
}
